import React from "react"
import {connect} from "react-redux"
import {Field, getFormValues, reduxForm, change, SubmissionError} from "redux-form"
import {AnalyticEvent, DirectCall, SubmitButton, TextInput, ToolTip} from "../../../components/forms"
import {InternationalCustomer} from "../../../api/international-customer";
import {CountryListSelectMenu} from "../../../components/forms/countrylist-selectmenu";
import {UserRegistration} from "../../../api/user-registration";
import {Errors} from "../../../api/util";
import Validators from "../../../validation"

let GetComponent = (props) => {

    return (
        <div className={"iata-get-component"}>
            <form className="row widget-form" onSubmit={props.handleSubmit}>
                <section>
                    <h3>Tell us your agent code</h3>
                    <Field id="agentCode" name="agentCode" placeholder="e.g. 0230000" title="IATA agent code" component={TextInput}>
                        <ToolTip text="This consists of a three digit country code, followed by your four digit agent code."/>
                    </Field>
                    <h5>If you have a CASS code, you let us know here (optional)</h5>
                    <Field id="cassCode" name="cassCode" placeholder="e.g. 1234" title="CASS code" component={TextInput}>
                        <ToolTip text="If you’re not sure of your CASS code, you can leave this field blank."/>
                    </Field>
                    <SubmitButton id="iata-submit-button" label="LOOKUP COMPANY DETAILS"/>
                </section>
            </form>
            <section className="row">
                <a className="internal-link" onClick={props.handleCreate}>I don't know my IATA agent code or CASScode</a>
            </section>
        </div>
    )
};

GetComponent = reduxForm({
    form: 'international/agent', destroyOnUnmount: false,
    asyncBlurFields: ['agentCode', 'cassCode']
})(GetComponent);
GetComponent = connect(state => {
    return {
        config: getFormValues('config')(state),
    }
})(GetComponent);

let ViewComponent = (props) => {

    return (
        <div className={"iata-view-component"}>
            <form className="row widget-form" onSubmit={props.handleSubmit}>
                <section className="lookup-section">
                    <h3>Your IATA agent code details</h3>
                    <h5>Agent code</h5>
                    <p className="code-text">{props.agent.agentCode}</p>
                    <h5>Cass code</h5>
                    <p className="code-text">{props.agent.cassCode}</p>

                    <div className="card-item">
                        <div className="card">
                            <h5 className="card__heading">{props.agent.company.name}</h5>
                            <button type="button" aria-label="Edit" onClick={props.edit}
                                    className={"iata-company-edit-btn"}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                    <g fill="#4A4A4A" fillRule="evenodd">
                                        <path
                                            d="M1.975 11.525L0 16l4.475-1.975zM14.425 4.275L16 2.725 13.3 0l-1.575 1.575zM11.025 2.275L2.575 10.7l2.7 2.725L13.725 5z"/>
                                    </g>
                                </svg>
                            </button>
                            <div className="card-details-text">{props.agent.company.streetaddress}</div>
                            <div className="card-details-text">{props.agent.company.city}</div>
                            <div className="card-details-text">{props.agent.company.state}</div>
                            <div className="card-details-text">{props.agent.company.postcode}</div>
                            <div className="card-details-text">{props.agent.company.country.label}</div>
                        </div>
                    </div>

                    <SubmitButton label="CONFIRM & CONTINUE" id={"iata-agent-cc-button"}/>

                </section>

            </form>
            <div className="row">
                <a className="internal-link" onClick={props.back}>Lookup another agent code</a>
            </div>
        </div>

    )

};

ViewComponent = connect(state => {
    let registration = getFormValues('registration')(state);
    let agent = getFormValues('international/agent')(state);

    let company = agent.company;

    return {
        config: getFormValues('config')(state),
        agent: agent,
        registration: {
            "firstName": registration.firstname,
            "status": "NEW",
            "lastName": registration.lastname,
            "email": registration.email,
            "phone": registration.phone,
            "username": registration.username,
            "password": registration.password,
            "registrationMethod": "INTERNATIONAL_COMPANY",
            "internationalCompany": {
                codes: {
                    agentCode: agent.agentCode,
                    cassCode: agent.cassCode.trim() || null
                },
                "name": company.name,
                "streetAddress": company.streetaddress,
                "city": company.city,
                "postcode": company.postcode,
                "state": company.state,
                "countryCode": company.country.value,
                "countryName": company.country.label
            }

        }
    }

})(reduxForm({
    form: 'international/agent', destroyOnUnmount: false,

})(ViewComponent));


let EditComponent = (props) => {

    return (
        <div className={"iata-edit-component"}>
            <form className="row widget-form" onSubmit={props.handleSubmit}>
                <section className="lookup-section">
                    <h3>Your IATA agent code details</h3>
                    <h5>Agent code</h5>
                    <p className="code-text">{props.agent.agentCode}</p>
                    <h5>Cass code</h5>
                    <p className="code-text">{props.agent.cassCode}</p>
                    <h3>Please confirm your company details</h3>
                    <Field name="company.name" placeholder="" title="Company name" component={TextInput}/>
                    <Field name="company.streetaddress" maxlength="50" placeholder="" title="Street address"
                           component={TextInput}/>
                    <Field name="company.city" placeholder="" title="City" component={TextInput}/>
                    <Field name="company.state" placeholder="" title="State" component={TextInput}/>
                    <Field name="company.postcode" placeholder="" title="Postcode" component={TextInput}/>
                    <CountryListSelectMenu name="company.country" title={"Country"}/>

                    <SubmitButton label="CONFIRM & CONTINUE" id={"iata-agent-submit-button"}/>
                </section>
            </form>
            <div className={"row"}>
                <a className={"internal-link"} onClick={props.back}>Lookup another agent code</a>
            </div>
        </div>
    )
};


EditComponent = connect(state => {
    let registration = getFormValues('registration')(state);
    let agent = getFormValues('international/agent')(state) || {

        company: {
            name: "",
            streetaddress: "", city: "", postcode: "", state: "", country: {value: "", label: ""}
        }
    };

    let company = agent.company;

    return {
        config: getFormValues('config')(state),
        agent: agent,
        registration: {
            "firstName": registration.firstname,
            "status": "NEW",
            "lastName": registration.lastname,
            "email": registration.email,
            "phone": registration.phone,
            "username": registration.username,
            "password": registration.password,
            "registrationMethod": "INTERNATIONAL_COMPANY",
            "internationalCompany": {
                codes: {
                    agentCode: agent.agentCode,
                    cassCode: agent.cassCode.trim() || null
                },
                "name": company.name,
                "streetAddress": company.streetaddress,
                "city": company.city,
                "postcode": company.postcode,
                "state": company.state,
                "countryCode": company.country.value,
                "countryName": company.country.label
            }

        }
    }

})(reduxForm({
    form: 'international/agent', destroyOnUnmount: false,
    asyncBlurFields: ['company.name', 'company.streetaddress', 'company.city', 'company.state', 'company.postcode'],
})(EditComponent));


let CreateComponent = (props) => {
    return (
        <div className={"iata-create-component"}>
            <form className="row widget-form" onSubmit={props.handleSubmit}>
                <section className="lookup-section">
                    <h3>Your IATA agent code details</h3>
                    <h5>Agent code</h5>
                    <p className="code-text">{props.agent.agentCode}</p>
                    <h5>Cass code</h5>
                    <p className="code-text">{props.agent.cassCode}</p>
                    <h3>Please confirm your company details</h3>
                    <Field name="company.name" placeholder="" title="Company name" component={TextInput}/>
                    <Field name="company.streetaddress" maxlength="50" placeholder="" title="Street address"
                           component={TextInput}/>
                    <Field name="company.city" placeholder="" title="City" component={TextInput}/>
                    <Field name="company.state" placeholder="" title="State" component={TextInput}/>
                    <Field name="company.postcode" placeholder="" title="Postcode" component={TextInput}/>
                    <CountryListSelectMenu name="company.country"/>
                    <SubmitButton label="SUBMIT & CONTINUE" id={"iata-agent-create-btn"}/>
                </section>
            </form>
            <div className={"row"}>
                <a className={"internal-link"} onClick={props.back}>Lookup another agent code</a>
            </div>
        </div>
    )
};

CreateComponent = reduxForm({
    form: 'international/agent', destroyOnUnmount: false,
    asyncBlurFields: ['company.name', 'company.streetaddress', 'company.city', 'company.state', 'company.postcode'],
})(CreateComponent);
CreateComponent = connect(state => {
    let registration = getFormValues('registration')(state);
    let agent = getFormValues('international/agent')(state) || {

        company: {
            name: "",
            streetaddress: "", city: "", postcode: "", state: "", country: {value: "", label: ""}
        }
    };

    let company = agent.company;
    return {
        config: getFormValues('config')(state),
        agent: getFormValues("international/agent")(state),

        registration: {
            "firstName": registration.firstname,
            "status": "NEW",
            "lastName": registration.lastname,
            "email": registration.email,
            "phone": registration.phone,
            "username": registration.username,
            "password": registration.password,
            "registrationMethod": "INTERNATIONAL_COMPANY",
            "internationalCompany": {
                codes: {
                    agentCode: agent.agentCode,
                    cassCode: agent.cassCode.trim() || null
                },
                "name": company.name,
                "streetAddress": company.streetaddress,
                "city": company.city,
                "postcode": company.postcode,
                "state": company.state,
                "countryCode": company.country.value,
                "countryName": company.country.label
            }

        }

    }
})(CreateComponent);

const VIEWS_GET = 0;
const VIEWS_VIEW = 1;
const VIEWS_EDIT = 2;
const VIEWS_CREATE = 3;

class IATAContainer extends React.Component {


    constructor(props) {
        super(props);
        this.state = {view: 0};
    }

    swapView = (index) => {
        this.setState({view: index})
    };


    render = () => {
        const handleSubmitSuccess = this.props.handleSubmitSuccess;
        const views = [
            <GetComponent key={1}
                          handleCreate={() => {
                              this.props.dispatch(Errors.clear());
                              this.props.dispatch(change('account', 'customer', {value: "company", label: "Company"}));
                          }}
                          validate={Validators.IataAgent.validate}
                          onSubmitSuccess={(result, dispatch, props) => {
                              this.swapView(VIEWS_VIEW);
                          }}
                          onSubmitFail={(errors, dispatch, submitErrors, props) => {
                              dispatch(Errors.clear());
                              if (submitErrors && submitErrors.errors || errors) {
                                  if (submitErrors.errors.status === 0 || submitErrors.errors.status >= 500 ) {
                                      dispatch(Errors.TechnicalError());
                                  }
                                  else if(submitErrors && submitErrors.errors && submitErrors.errors.status >= 400){
                                      dispatch(Errors.InvalidFormSubmission());
                                  }
                                  else if (errors || (submitErrors && submitErrors.errors)) {
                                      dispatch(Errors.InvalidFormSubmission());
                                      this.swapView(VIEWS_CREATE);
                                  }
                              }
                          }}
                          onSubmit={(values, dispatch, props) => {
                              dispatch(Errors.clear());

                              const lookup = {
                                  agentCode: values.agentCode,
                                  cassCode: values.cassCode.trim() || null
                              };
                              return InternationalCustomer(props.config.customer).validate(lookup).then(
                                  (response) => {
                                      dispatch(change('international/agent', 'company', response.data));
                                  },
                                  (error) => {
                                      if (error.status === 404) {
                                          throw new SubmissionError({"iata": {message: error.message}})
                                      }
                                      else if (error.status === 0 || error.status >= 400) {
                                          throw new SubmissionError({_error: error.message, status: error.status})
                                      }
                                      else {
                                          throw new SubmissionError({_error: error.message});
                                      }
                                  }
                              )
                          }
                          }

            />,


            <ViewComponent key={2}
                           onSubmitSuccess={(results, dispatch, props) => {
                               dispatch(Errors.clear());
                               AnalyticEvent(window.dataLayer,{
                                   "eventInfo": {
                                       "eventName":"registrationStep4",
                                       "eventAction": "2",
                                   },

                                   "attributes": {
                                       "shippingType": "Outside Australia",
                                       "customerType": "IATA certified agent",
                                       "existingCompanyAccount": "No"
                                   }
                               }).then(() => {
                                    DirectCall(window._satellite, "lookupCustomerDetails")
                                }, ()=> {});
                               handleSubmitSuccess(results, dispatch, props);
                           }}
                           onSubmitFail={(errors, dispatch, submitErrors, props) => {
                               AnalyticEvent(window.dataLayer,{
                                   "eventInfo": {
                                       "eventName": "registrationFailed",
                                   }
                               }).then(() => {
                                 DirectCall(window._satellite, "registrationFailed")
                                }, ()=> {});
                               if (submitErrors && submitErrors.errors || errors) {
                                   if (submitErrors.errors.status === 0 || submitErrors.errors.status >= 500) {
                                       dispatch(Errors.TechnicalError());
                                   }
                                   else if(submitErrors && submitErrors.errors && submitErrors.errors.status >= 400){
                                       dispatch(Errors.InvalidFormSubmission());
                                   }
                                   else if (errors || (submitErrors && submitErrors.errors)) {
                                       dispatch(Errors.InvalidFormSubmission());
                                       this.swapView(VIEWS_CREATE);
                                   }
                               }
                           }}
                           onSubmit={(values, dispatch, props) => {
                               dispatch(Errors.clear());
                               return UserRegistration(props.config.userreg).Create(props.registration)
                                   .then(() => {
                                   }, (error) => {
                                       if (error.status === 0 || error.status >= 500) {
                                           throw new SubmissionError({status: error.status})
                                       }
                                       else if (error.status >= 400) {
                                           throw new SubmissionError({status: error.status})
                                       }
                                       else {
                                           throw new SubmissionError({_error: error.message})
                                       }
                                   });
                           }}
                           edit={() => {
                               this.swapView(VIEWS_EDIT)
                           }}
                           back={() => {
                               this.swapView(VIEWS_GET)
                           }}
            />,


            <EditComponent key={3} back={() => {
                this.swapView(0)
            }}
                           onSubmitSuccess={(result, dispatch, props) => {
                               dispatch(Errors.clear());
                               this.swapView(1)
                           }}
                           onSubmitFail={(errors, dispatch, submitErrors, props) => {
                               dispatch(Errors.clear());
                               if ((submitErrors && submitErrors.errors) || errors) {

                                   if (submitErrors && submitErrors.errors && (submitErrors.errors._error.status === 0 || submitErrors.errors._error.status >= 500)) {
                                       dispatch(Errors.TechnicalError())
                                   }
                                   else if (submitErrors && submitErrors.errors && (submitErrors.errors._error.status >= 400)) {
                                       dispatch(Errors.InvalidFormSubmission());
                                       this.swapView(2)

                                   }
                                   else if (errors || (submitErrors && submitErrors.errors)) {
                                       dispatch(Errors.InvalidFormSubmission());
                                   }
                               }
                           }}
                           onSubmit={(values, dispatch, props) => {
                               dispatch(Errors.clear());
                           }}
                           validate={(values) => {
                               return Validators.Company.validate(values);
                           }}
            />

            ,

            <CreateComponent back={() => {
                this.swapView(VIEWS_GET)
            }}
                             onSubmitSuccess={(result, dispatch, props) => {
                                AnalyticEvent(window.dataLayer,{
                                   "eventInfo": {
                                       "eventName":"registrationStep4",
                                       "eventAction": "2",
                                   },

                                   "attributes": {
                                       "shippingType": "Outside Australia",
                                       "customerType": "IATA certified agent",
                                       "existingCompanyAccount": "No"
                                   }
                               }).then(() => {
                                    DirectCall(window._satellite, "lookupCustomerDetails")
                                }, ()=> {});
                                 handleSubmitSuccess(result, dispatch, props);
                             }}
                             onSubmitFail={(errors, dispatch, submitErrors, props) => {
                                 AnalyticEvent(window.dataLayer,{
                                     "eventInfo": {
                                         "eventName": "registrationFailed",
                                     }
                                 }).then(() => {
                                    DirectCall(window._satellite, "registrationFailed")
                                }, ()=> {});
                                 dispatch(Errors.clear());
                                 if ((submitErrors && submitErrors.errors) || errors) {
                                     if (submitErrors && submitErrors.errors && (submitErrors.errors.status === 0 || submitErrors.errors.status >= 500)) {
                                         dispatch(Errors.TechnicalError());
                                     }
                                     else if(submitErrors && submitErrors.errors && submitErrors.errors.status >= 400){
                                         dispatch(Errors.InvalidFormSubmission());
                                     }
                                     else {
                                         dispatch(Errors.InvalidFormSubmission());
                                     }
                                 }
                             }}
                             onSubmit={(values, dispatch, props) => {
                                 dispatch(Errors.clear());
                                 return UserRegistration(props.config.userreg).Create(props.registration)
                                     .then(() => {
                                     }, (error) => {
                                         if (error.status === 502) {
                                             dispatch(Errors.TechnicalError());
                                             throw new SubmissionError({"username": {message: "Username already taken"}})

                                         }
                                         else if (error.status === 0 || error.status >= 400) {
                                             throw new SubmissionError({status: error.status, message: error.message})
                                         }
                                         else {
                                             throw new SubmissionError({_error: error.message})
                                         }
                                     });
                             }

                             }

                             validate={(values) => {
                                 return Validators.Company.validate(values);
                             }}
            />

        ];
        return (views[this.state.view])
    }

}

IATAContainer.defaultProps = {
    handleSubmitSuccess: (result, dispatch, props) => {
    }
};

IATAContainer = connect(state => {

    return {
        config: getFormValues('config')(state),
        international: {
            agent: getFormValues('international/agent')(state)
        }
    }

})(IATAContainer);

export {
    IATAContainer
}

